import { ReactNode } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import CSS from 'csstype';

import { classNames } from "~/utils/utils";

export interface IMyCheckbox {
	checked: boolean;
	label: ReactNode;
	sx?: CSS.Properties;
	className?: string;
	onChange: (checked: boolean) => void;
}

export default function MyCheckbox({
	checked,
	label,
	sx,
	className = "",
	onChange,
}: IMyCheckbox) {
	return <FormControlLabel
		control={<Checkbox disableRipple sx={{ "m": 1, '&': { marginRight: 0 } }} checked={checked} onChange={event => onChange(event.target.checked)} />}
		label={label}
		className={classNames([className])}
		sx={sx}
	/>;
}
